import React from 'react';
import { Link } from 'react-router-dom';
import aa from "../../assests/uncle_aunty.png";

function About() {
  return (
    <section className="about" id="about">
      <div className="about-text">
        <p className="section-eyebrow">Who We Are</p>
        <h2 className="section-title script orange">Christ Is For India!</h2>
        <div className="dots orange-dots">• • • •</div>
        <p><em>Christ For India</em> is a nonprofit organization, supporting a ministry's campus in{" "}
          <strong>Visakhapatnam</strong>, east of India, and led by <strong>Rev. Jameson P. Titus</strong>.
          His parents, <strong>Dr. P.J. and Mary Titus founded the ministry in 1981</strong> when they
          sold their house in the United States and moved back to India.</p>
        <p><em>Christ For India</em> began with one vision:{" "}
          <strong>Reaching One Billion Plus Souls For Christ.</strong></p>
        <p>In addition to <strong>spreading the Gospel</strong>, Dr. P.J. and Mary Titus were concerned
          about <strong>orphaned and poor children.</strong></p>
        <div className="about-btns">
          <Link to="/our-story" className="btn-outline-dark" style={{ textDecoration: "none" }}>OUR STORY</Link>
          <Link to="/our-team" className="btn-outline-dark" style={{ textDecoration: "none" }}>OUR TEAM</Link>
        </div>
      </div>
      <div className="about-images">
        <div className="about-img-top">
          <div className="about-img-placeholder bw">
            <img src={aa} alt="" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
